import FetchClient, { type ApiResponse } from "./FetchClient";

interface StoreActivityResponse {
  retailer: string;
  windowHours: number;
  activity: Record<string, boolean>;
}

export async function getStoreActivity(
  retailer: string,
  storeIds: string[]
): Promise<Record<string, boolean>> {
  const uniqueStoreIds = [...new Set(storeIds.map((id) => id.trim()).filter(Boolean))];
  if (uniqueStoreIds.length === 0) return {};

  const response = await FetchClient.post<ApiResponse<StoreActivityResponse>>(
    "/store-activity",
    { retailer, storeIds: uniqueStoreIds },
    { headers: { "Content-Type": "application/json" } }
  );
  return response.data.activity;
}
